module.exports = __webpack_public_path__ + "static/media/tesla-logo-font-download-1200x675.456f380b.jpg";